import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { Construction as ConstructionIcon } from '@mui/icons-material';

/**
 * Banner shown at the top of static, not-yet-wired feature screens so it is
 * unmistakable during demos that the page is a design mockup — recording and
 * AI generation are not connected to the backend yet.
 */
export default function DesignPreviewBanner({
  message = 'This screen is a static mockup for design review. Recording and AI generation are not wired up yet.',
  sx,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1.25,
        mb: 3,
        borderRadius: 2,
        border: '1px dashed',
        borderColor: 'warning.main',
        bgcolor: 'rgba(217, 119, 6, 0.08)',
        ...sx,
      }}
    >
      <ConstructionIcon sx={{ color: 'warning.main' }} />
      <Box sx={{ flex: 1 }}>
        <Typography variant="subtitle2" sx={{ color: '#92400e', fontWeight: 700, lineHeight: 1.2 }}>
          In development — design preview only
        </Typography>
        <Typography variant="caption" sx={{ color: '#92400e' }}>
          {message}
        </Typography>
      </Box>
      <Chip
        label="Design review"
        size="small"
        sx={{ bgcolor: 'warning.main', color: '#fff', fontWeight: 700, display: { xs: 'none', sm: 'inline-flex' } }}
      />
    </Box>
  );
}
